var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 53.064,
    viewBox: "0 0 53.5 53.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    d: "M228.072,5.656h-28.44a1.712,1.712,0,0,0-1.711,1.712V19.447L199.158,18a3.94,3.94,0,0,1,2.186-1.289V9.08h25.017V31.44H201.344V27.7l-.771.9a3.975,3.975,0,0,1-2.652,1.37v3.184a1.711,1.711,0,0,0,1.711,1.711h9.236l-4.693,21.3a1.771,1.771,0,0,0,3.458.763l4.86-22.067h2.825l4.86,22.067a1.771,1.771,0,1,0,3.458-.763l-4.692-21.3h9.126a1.712,1.712,0,0,0,1.711-1.711V7.368A1.713,1.713,0,0,0,228.072,5.656Z",
    transform: "translate(-176.284 -5.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    d: "M186.348,93.7a.66.66,0,0,0-.857-.372l-10.083,3.559a2.214,2.214,0,0,0-3.032.309l-3.2,3.736L166.339,98.5c.019.2.061.4.061.6v5.279l1.578,1.352a2.215,2.215,0,0,0,3.121-.24l3.809-4.454,3.072-1.8,8.084-4.73A.66.66,0,0,0,186.348,93.7Z",
    transform: "translate(-148.154 -83.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    d: "M12.017,105.776h-1.9a4.434,4.434,0,0,0-3.547,1.785l-5.833,5.37a2.213,2.213,0,0,0-.173,3.126l4.759,5.311a2.213,2.213,0,1,0,3.3-2.953l-3.28-3.663L10,110.584,7.284,114.27l2.654,2.963a3.971,3.971,0,0,1-4.278,6.4s.021,10.239.021,21.2a2.656,2.656,0,0,0,5.311,0V129.012h1.771v15.827a4.392,4.392,0,0,1-.554,2.1,2.625,2.625,0,0,0,1.6.553,2.656,2.656,0,0,0,2.656-2.656c0-10.962,0-6.367,0-34.607A4.455,4.455,0,0,0,12.017,105.776Z",
    transform: "translate(0 -94.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    d: "M56.687,11.747a4.975,4.975,0,0,0,4.731,0,5.176,5.176,0,1,0-4.731,0Z",
    transform: "translate(-47.986 -1.995)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducatorIcon);
export default __webpack_public_path__ + "static/media/educator-icon.89c3ee274599dcd00e4451198be78c87.svg";
export { ForwardRef as ReactComponent };